/* eslint-disable check-file/filename-blocklist */
export const EDITOR_MODE = {
	ADD: 'addComment',
	EDIT: 'editComment',
	REPLY: 'replyComment',
	RESET: null,
};

export const STATUS_CODES = {
	CONFLICT_ERROR: 409,
	BAD_REQUEST_ERROR: 400,
	PERMISSIONS_ERROR: 403,
	NOT_FOUND_ERROR: 404,
	RATE_LIMITING_ERROR: 429,
	UNAUTHORIZED_ERROR: 401,
};

export const ERROR_TYPES = {
	UNHANDLED_ERROR: 'unhandled_error',
	KNOWN_ERROR: 'known_error',
};

export const NEW_COMMENT_ID = 'newComment';
